module.exports = __webpack_public_path__ + "static/media/1.5987f882.png";